<template>
  <v-row>
    <v-col>
      <v-card
        :class="$vuetify.breakpoint.xsOnly ? 'pa-2' : 'py-4 px-2'"
        no-body
      >
        <div class="title mb-4 text-body-1">
          สถานะการอนุมัติ
        </div>
        <v-timeline dense class="ml-n6">
          <v-timeline-item
            v-for="(item, index) in leaveTimeline"
            :key="index"
            :color="item.color"
            small
          >
            <v-card outlined>
              <v-row>
                <v-col class="pa-6">
                  <div>
                    <span class="text-body-2">{{ item.name }}</span>
                    <span v-if="item.date" class="text-body-2">
                      , เมื่อ {{ item.date }}</span
                    >
                  </div>
                  <div>
                    <span class="text-body-2">{{ item.approved }}</span>
                  </div>
                  <div v-if="item.reject" class="error--text">
                    <span class="text-body-2">
                      ถูกตีกลับ : {{ item.reject.date }} จาก
                      {{ item.reject.name }}
                    </span>
                  </div>
                  <div v-if="item.reject" class="error--text">
                    <span class="text-body-2">
                      เหตุผลการตีกลับ : {{ item.reject.description }}
                    </span>
                  </div>
                  <div v-if="item.reason">
                    <span class="text-body-2">เหตุผล : {{ item.reason }}</span>
                  </div>
                </v-col>
              </v-row>
            </v-card>
          </v-timeline-item>
        </v-timeline>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: {
    leaveTimeline: {
      type: Object,
      default: () => []
    }
  }
}
</script>

<style lang="scss" scoped></style>
